import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petitionGuidesArticle',
		path: '/petition-guides/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/petition_guides" */ './index'), {
			exportName: 'PetitionGuides',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
	},
];
